import InitialValue from "./initialValue";
import { createContext } from "react";

const AuthContext = createContext(InitialValue.auth);

export default AuthContext;
